// extracted by mini-css-extract-plugin
export default {"products":"Kw-z","card":"Lw-z","oosMessaging":"Mw-z"};